import { connect } from 'react-redux';
import { withSagas } from 'decorators/Sagas';
import { decorateWith, withName } from 'helpers/decorator';
import { isLoggedIn } from 'redux/modules/user';
import { SearchMap } from './SearchMap';
import {
  selectPopup,
  selectIsSearchable,
  clearPopup,
  selectHighlightedVenueId,
  selectViewport,
  setMapLoaded,
} from './SearchMap.reducer';
import { watchSearchMap, onMapMove, onMapSearch, onMarkerSelected, updateViewport } from './SearchMap.saga';
import {
  getUserLocationForSearch,
  selectMapItemsInLayout,
  selectResultsLayout,
  selectIsMobileMapView,
} from '../Search.helpers';
import { closeOpenPanel } from '../SearchBox/SearchBox.reducer';

export const mapStateToProps = state => {
  const { data: searchData, loading } = selectResultsLayout(state);
  const venues = selectMapItemsInLayout(searchData);
  const location = getUserLocationForSearch(state);

  const longitude = location.lon;
  const latitude = location.lat;

  return {
    loading,
    location,
    venues,
    highlightedVenueId: selectHighlightedVenueId(state),
    popup: selectPopup(state),
    isSearchable: selectIsSearchable(state),
    viewport: selectViewport(state),
    longitude,
    latitude,
    isLoggedIn: isLoggedIn(state),
    isMapSearch: location.isMapSearch,
    isMobileMapView: selectIsMobileMapView(state),
  };
};

export const mapDispatchToProps = {
  onMapSearch,
  onMapMove,
  onMarkerSelected,
  onMapClick: clearPopup,
  closeOpenPanel,
  updateViewport,
  setMapLoaded,
};

export const SearchMapContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withSagas({
    watch: [watchSearchMap],
  }),
  withName('SearchMapContainer')
)(SearchMap);
